import React from 'react'
import Header from '../include/Header'
// import { Link } from 'react-router-dom'
import Footer from '../include/Footer'
function PrivacyPolicy() {
    return (
        <>
            <Header />
            <div className="page-header bg-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12">
                            <div className="page-header-box">
                                <h1 className="wow fadeInUp" data-cursor="-opaque">Privacy Policy</h1>
                                {/* <nav className="wow fadeInUp" data-wow-delay="0.2s">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/">home</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">Privacy Policy</li>
                                    </ol>
                                </nav> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cta-box">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="cta-box-content">
                                <div className="section-title">
                                    {/* <h5 className="wow fadeInUp">Merchant Legal entity name:</h5> */}
                                    <h5 className="wow fadeInUp">Privacy Policy</h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        <b>Innosutra AI Private Limited</b> (“Company”, “Innosutra”, “we”, “our”, or “us”) values the privacy of
                                        individuals (“you”, “your”, “user”) who access and use our website or mobile application currently branded
                                        as <b>“Wallpaper App” </b> (the “Service”).
                                        <br /><br />
                                        This Privacy Policy explains how we collect, use, store, and disclose information obtained through the Service. It forms an integral part of our Terms of Use (“ToU”).
                                        Any capitalized terms not defined here shall have the meanings assigned to them in the ToU.
                                        <br /><br />
                                        By accessing or using the Service, you confirm that you have read, understood, and agreed to this Privacy Policy. If you do not agree with any part of this Policy, you should discontinue use of the Service.
                                    </p>
                                    <br></br>   <br></br>
                                    <h5 className="wow fadeInUp">1. Updates to This Policy</h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        We may revise this Privacy Policy from time to time to reflect changes in business operations, legal obligations, or regulatory requirements. Updated versions will be made available within the Service.
                                        <ul>
                                            <li>Changes become effective immediately upon posting.</li>
                                            <li>Continued use of the Service indicates acceptance of the updated Policy.</li>
                                            <li>We may restrict or suspend access if we believe this Policy has been violated.</li>
                                        </ul>
                                    </p>
                                    <br></br>   <br></br>
                                    <h5 className="wow fadeInUp">2. Sensitive Personal Information</h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        We do not request and you must not share any sensitive personal data with us.
                                        <br />
                                        This includes (but is not limited to):
                                        <ul>
                                            <li>Passwords.</li>
                                            <li>Bank or payment details (credit/debit cards, PINs, etc.)</li>
                                            <li>Health or medical information</li>
                                            <li>Biometric data</li>
                                            <li>Sexual orientation</li>
                                            <li>National identification numbers</li>
                                        </ul>
                                        <br />
                                        Any such information shared will be entirely at your own risk, and the Company will not be responsible for its misuse.
                                        <br />
                                        We also do not collect payment data directly. If payments are required, they are handled by third-party payment providers. You are advised to review their privacy policies before sharing any information.
                                    </p>
                                    <br></br>   <br></br>
                                    <h5 className="wow fadeInUp">3. Types of Information We Collect</h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        We may collect the following categories of data:
                                        <br />
                                        <b>a) Personal Information</b>
                                        Information that can identify you, such as:
                                        <ul>
                                            <li>Name</li>
                                            <li>Phone number</li>
                                            <li>Email address</li>
                                            <li>Date of birth</li>
                                            <li>Gender</li>
                                            <li>Location data</li>
                                            <li>IP address</li>
                                            <li>Device information</li>
                                            <li>Profile image</li>
                                        </ul>
                                        <b>Non-Personal Information</b>
                                        Information that does not directly identify you, such as:
                                        <ul>
                                            <li>Usage data</li>
                                            <li>Cookies and tracking data</li>
                                            <li>Log information</li>
                                            <li>Analytics data</li>
                                        </ul>
                                        <br />
                                        You confirm that any data provided by you is accurate and that you have the right to share it.
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">4. How We Collect Information</h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        We collect information through various means, including:
                                        <br />
                                        <ul>
                                            <li>Registration and account creation</li>
                                            <li>User activity within the Service</li>
                                            <li>Cookies and similar tracking technologies</li>
                                            <li>Emails or communication sent to us</li>
                                            <li>Participation in surveys, promotions, or campaigns</li>
                                            <li>Social media integrations (if applicable)</li>
                                            <li>User-generated content uploaded on the platform</li>
                                        </ul>
                                        <br />
                                        We may combine information from multiple sources to improve user experience.
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">5. Purpose of Data Collection</h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        We use collected information for purposes such as:
                                        <br />
                                        <ul>
                                            <li>Account creation and authentication (including OTP verification)</li>
                                            <li>Providing and maintaining the Service</li>
                                            <li>Personalizing user experience and recommendations</li>
                                            <li>Processing transactions</li>
                                            <li>Customer support and communication</li>
                                            <li>Sending updates, offers, and notifications</li>
                                            <li>Monitoring usage and improving performance</li>
                                            <li>Analytics and research</li>
                                            <li>Marketing and promotional activities</li>
                                            <li>Ensuring platform security and preventing misuse</li>
                                            <li>Compliance with legal and regulatory requirements</li>
                                        </ul>
                                        <br />
                                        Non-personal data is primarily used for analytics, improving functionality, and understanding user behavior.
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">6. Cookies and Tracking Technologies</h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        We use cookies and similar technologies to:
                                        <br />
                                        <ul>
                                            <li>Enhance user experience</li>
                                            <li>Understand user preferences</li>
                                            <li>Analyze usage patterns</li>
                                        </ul>
                                        <br />
                                        You may choose to disable cookies through your browser settings, though some features of the Service may not function properly.
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">7. Data Sharing and Disclosure</h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        We do not<b> sell or rent </b>your personal information.
                                        <br />
                                        However, we may share information in the following situations:
                                        <br />
                                        <ul>
                                            <li>With service providers and vendors assisting in operations</li>
                                            <li>With partners for marketing or promotional purposes (with opt-out options)</li>
                                            <li>With legal authorities when required by law</li>
                                            <li>To protect our rights, users, or property</li>
                                            <li>During business transfers (e.g., merger or acquisition)</li>
                                        </ul>
                                        <br />
                                        Certain limited data (excluding profile images) may be shared with third-party services for analytics, personalization, and advertising.
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">8. Data Security</h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        We implement reasonable security practices as per applicable laws to protect your data.
                                        <br />
                                        However:
                                        <br />
                                        <ul>
                                            <li>No system is completely secure</li>
                                            <li>Data transmission over the internet carries inherent risks</li>
                                            <li>You share information at your own risk</li>
                                        </ul>
                                        <br />
                                        We are not liable for breaches unless caused by proven negligence.
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">9. Data Storage and Transfer</h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        Your data may be stored electronically or physically and may be processed in locations outside India, in compliance with applicable laws.
                                        <br />
                                        We may engage third-party providers for storage and processing, who are expected to follow reasonable security standards.
                                        <br />
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">10. Data Retention</h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        We retain personal data only as long as necessary for:
                                        <br />
                                        <ul>
                                            <li>Providing services</li>
                                            <li>Legal compliance</li>
                                            <li>Dispute resolution</li>
                                            <li>Enforcement of agreements</li>
                                        </ul>
                                        <br />
                                        After that, data is securely deleted or anonymized.
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">11. Third-Party Services</h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        The Service may contain links to third-party websites or applications.
                                        <br />
                                        <ul>
                                            <li>These platforms have their own privacy policies</li>
                                            <li>We are not responsible for their practices</li>
                                            <li>You should review their policies before sharing data</li>
                                        </ul>
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">12. User Rights (Access, Correction, Deletion)</h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        You may:
                                        <br />
                                        <ul>
                                            <li>Request access to your data</li>
                                            <li>Request corrections</li>
                                            <li>Request deletion</li>
                                        </ul>
                                        <br />
                                        To do so, contact us at:
                                        &nbsp;<b>
                                            innosutraaiprivatelimited@gmail.com
                                        </b>
                                        <br />
                                        Note: Deleting certain data may affect your ability to use the Service.
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">13. Withdrawal of Consent</h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        You may withdraw consent at any time by:
                                        <br />
                                        <ul>
                                            <li>Discontinuing use of the Service</li>
                                            <li>Requesting data removal via email</li>
                                        </ul>
                                        However, this may limit or stop access to certain features.
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">14. Force Majeure</h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        We are not responsible for data loss or breaches caused by events beyond our control, including:
                                        <br />
                                        <ul>
                                            <li>Natural disasters</li>
                                            <li>Cyberattacks</li>
                                            <li>Government actions</li>
                                            <li>System failures</li>
                                        </ul>
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">15. Contact & Support</h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        For any concerns, complaints, or queries related to this Privacy Policy, please contact:
                                        <br />
                                        innosutraaiprivatelimited@gmail.com
                                    </p>
                                </div>
                                <div className="cta-section-shape">
                                    <img src="/assets/images/section-bg-shape-1.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default PrivacyPolicy
